import {initializeIcons} from "office-ui-fabric-react/lib/Icons";

import Loader from './Loader.js';

import React from 'react';
import Header from './sections/Header.js';
import Sections from './sections/Sections.js';
//for some reason this applies to root

import SideNav from './containers/SideNav.js';
import './Background.css';




export default class App extends React.Component {
  constructor(props)
  {
    initializeIcons();
    super(props);
    this.state = {
      loaded : false
    }

  }

  componentDidMount() {

    window.onload = () => {
      setTimeout( () => 
      {
          this.setState({
          loaded: true
        })
      }, 3500)
    }
  }


  render() {
    var loaded = this.state.loaded;

    if(loaded)
    {
      return (
        <div id = "Main">
          <SideNav tabs = {[
            {
              label: "Home",
              event: () => {window.location.href = "#Header"}
            }
          ]}/>
          <Loader loaded = {loaded}/>
          <Header/>
          <Sections/>
        </div>
      )
    }
    else
    {
      return <Loader loaded = {loaded}/>;
    }
  }
}



